const FeatureCheck = {
  canCompress: () => true,
  canEncrypt: () => true,
}

export default FeatureCheck
